import { render, staticRenderFns } from "./CarbonEmissionCard.vue?vue&type=template&id=39a6dbe6&scoped=true"
import script from "./CarbonEmissionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarbonEmissionCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarbonEmissionCard.vue?vue&type=style&index=0&id=39a6dbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a6dbe6",
  null
  
)

export default component.exports